import { render, staticRenderFns } from "./BuyNewPlanBtn.vue?vue&type=template&id=51e7e7aa&scoped=true&"
import script from "./BuyNewPlanBtn.vue?vue&type=script&lang=js&"
export * from "./BuyNewPlanBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7e7aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
